import React from "react";
import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Notice from "../components/Notice";
import Modal from "../components/Modal";

function Community() {
  const noticeData = [
    {
      key: 1,
      title: "코끼리협동조합 홈페이지 리뉴얼 안내",
      data: `2023년 11월 중 코끼리협동조합 홈페이지 리뉴얼 예정입니다.`,
      // img: "../assets/img/notice1.jpg",
      img: null,
      date: "23-11-27",
      count: 1,
    },
    // {
    //   key: 2,
    //   title: "공지사항 제목 2",
    //   data: `GeeksforGeeks is a one stop solution  
    //               for all computer science students.`,
    //   img: null,
    //   date: "23-11-01",
    //   count: 2,
    // },
    // {
    //   key: 3,
    //   title: "공지사항 제목 3",
    //   data: `GeeksforGeeks is a one stop solution  
    //               for all computer science students.`,
    //   img: null,
    //   date: "23-11-09",
    //   count: 3,
    // },
    // {
    //   key: 4,
    //   title: "공지사항 제목 4",
    //   data: `GeeksforGeeks is a one stop solution`,
    //   img: null,
    //   img: "../assets/img/notice2.jpg",
    //   date: "23-11-24",
    //   count: 4,
    // },
    // {
    //   key: 5,
    //   title: "공지사항 제목 5",
    //   data: `GeeksforGeeks is a one stop solution  
    //               for all computer science students.`,
    //   img: null,
    //   date: "23-11-25",
    //   count: 5,
    // },
    // {
    //   key: 6,
    //   title: "공지사항 제목 6",
    //   data: `GeeksforGeeks is a one stop solution  
    //               for all computer science students.`,
    //   img: null,
    //   date: "23-11-30",
    //   count: 6,
    // },
  ];

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);

  const openModal = (notice) => {
    setSelectedNotice(notice);
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedNotice(null);
    setModalVisible(false);
  };

  return (
    <div className="container mx-auto">
      <div className={`flex flex-col gap-40 px-4 pb-52 pt-28 mt-72 ${modalVisible ? 'hidden' : ''}`}>
        {/* section1 */}
        <section className="flex flex-col items-center justify-center w-full px-24">
          <div className="flex w-full rounded-t-2xl text-lg items-center text-gray-800 h-14 bg-gray-100">
            <p className="w-1/6 text-center">번호</p>
            <p className="w-3/6 text-center">제목</p>
            <p className="w-1/6 text-center">작성일</p>
            <p className="w-1/6 text-center">조회수</p>
          </div>
          <div className="w-full border-t-2 border-gray-300">
            {noticeData.map((data) => (
              <Notice
                key={data.key}
                num={data.key}
                title={data.title}
                data={data.data}
                date={data.date}
                img={data.img}
                count={data.count}
                openModal={() => openModal(data)}
                setModalVisible={setModalVisible}
              />
            ))}
          </div>
        </section>
      </div>
      {modalVisible && (
        <Modal
          isOpen={modalVisible}
          title={selectedNotice.title}
          date={selectedNotice.date}
          count={selectedNotice.count}
          img={selectedNotice.img}
          data={selectedNotice.data}
          onClose={closeModal}
        />
      )}
    </div>
  );
}

AOS.init();
export default Community;
